import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from '../../utils/api.services';



const initialState = {
    isLoading: false,
    countryList: {
        data: [],
        error: null,
    },
}

const masterSlice = createSlice({
    name: 'masterslice',
    initialState,
    reducers: {
        setLoader: (state, action) => {
            state.isLoading = action.payload;
        },
    },
   
});

export const { setLoader } = masterSlice.actions;
export default masterSlice.reducer;